import * as React from 'react';
// import {useState} from 'react';
// import { useSelector } from 'react-redux';
import {Grid,Box} from '@mui/material';
import Tree from "react-d3-tree";
import "../../style.css";
import NodeLbl from '../../NodeLabel/NodeLbl';

const test = {
    shape: "rect",
    shapeProps: {
        width: 0,
        height: 0,
        x: -20,
        y: 20,
        stroke: "#2F80ED"
    }
};
// const nodeStyle = (React.createElement("svg", { viewbox: "0 0 100 60", xmlns: "http://www.w3.org/2000/svg" },
//     React.createElement("rect", { width: "80", height: "40", x: "10", y: "10", style: "fill: skyblue; stroke: cadetblue; stroke-width: 2;" })));
// const treeStyle = {
//     nodes: {
//         node: {
//             circle: React.createElement("nodeStyle", null),
//             name: React.createElement("nodeStyle", null),
//             attributes: React.createElement("nodeStyle", null)
//         }
//     }
//};
// interface NodeLabelProps {
//     className: string;
//     nodeData: {
//       name: string;
//     };
//   }
  
  const ShowVertical = ({dataa} : any) => {
    
    // const [objNameIds, setObjNameIds] = useState<any>();
    
    // const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
    // const onSuccesssGetAllObjectiveData = (data: any) => {
    //   setObjNameIds(data);
    // };
    const dataaa = [
      {
          name: "",
          children: [
          ]
      }
  ];

    return (
     <Grid item xs={12}>
       <Box>
        <div className="AppVer">
        <div id="treeWrapper"  style={{ width:'100%', height: '75vh'}}>
          <Tree
            data={dataa !== undefined && dataa != null ? dataa : dataaa}
            nodeSvgShape={test}
            pathFunc="straight"
            separation={{ siblings: 1.55 , nonSiblings: 1.55 }}
            orientation="vertical"
            translate={{ x: 900, y: 55 }}
            allowForeignObjects
            nodeLabelComponent={{
              render: <NodeLbl className="myLabelComponentInSvg" nodeData={{name:'',type:'',score : null}}/>,
              foreignObjectWrapper: {
                width: 190,
                height: 110,
                y: -20,
                x: -130,
              },
            }}
            zoomable= {true}
            initialDepth={0.02}
            shouldCollapseNeighborNodes={true}
          />
        </div>
      </div>
      </Box>
      
     </Grid>
    );
  };
  
export default ShowVertical